
export interface SearchDeviceIdentityDto {
    macAddresses?: string[];
    netBiosName?: string;
    netBiosDomain?: string;
    systemName?: string;
    systemOID?: string;
    ipAddresses?: string[];
    hostName?: string;
    serialNumbers?: string[];
    dependentDeviceController?: SearchDeviceIdentityDto;
    dependentDeviceControllerLabel?: string;
}


export class SearchDeviceObservationDto {
    deviceGuid: string;
    agentGuid: string;
    agentName: string;
    schedDiscGuid: string;
    schedDiscName: string;
    timeStampUtc: string;
}


export class SearchDeviceListEntryDto {
    guid: string;
    userGuid: string;
    userName: string;
    scopeGuid: string;
    scopeName: string;
    identity: SearchDeviceIdentityDto;
    deviceObservations: SearchDeviceObservationDto[];
}


export class SearchDeviceListDto {
    entries: SearchDeviceListEntryDto[];
    totalCount: number;
}
